import { useEffect } from "react";

import { loadDevMessages, loadErrorMessages } from "@apollo/client/dev";
import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

import { DEPLOY_ENV, DEV, RELEASE_HASH, SENTRY_DSN } from "./config";

//////////////////////////////////////////////////////////////////////////////
// Apollo                                                                   //
//////////////////////////////////////////////////////////////////////////////

if (DEV) {
  loadDevMessages();
  loadErrorMessages();
}

//////////////////////////////////////////////////////////////////////////////
// Sentry                                                                   //
//////////////////////////////////////////////////////////////////////////////

Sentry.init({
  dsn: SENTRY_DSN,
  environment: DEPLOY_ENV,
  release: RELEASE_HASH,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.browserProfilingIntegration(),
  ],
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0.8,
  // The profiling decision is made once per session when the SDK initialises.
  // Requires the `Document-Policy: js-profiling` response header on the
  // document (set via the Vite dev server and the CloudFront response headers
  // policy in infra).
  profileSessionSampleRate: 1.0,
  profileLifecycle: "trace",
});
